import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@mui/styles';
import dayjs from 'dayjs';
import logo from '../../assets/img/logo_degradado.png';
import { SocketContext } from '../../contexts/SocketContext';
import { useTextSpeech } from '../../hooks/turns/useTextSpeech';
import { AlertContext } from '../../contexts/AlertContext';
import { LoaderContext } from '../../contexts/LoaderContext';
import '../../App.css';
import { useParams } from 'react-router-dom';

let timeId;

export const Visualizador = () => {

    //*Styles
    const classes = useStyles();
    //*States
    const [calling, setCalling] = useState(false);
    const [animated, setAnimated] = useState('');
    const [date, setDate] = useState(dayjs().format("DD-MM-YYYY"));
    const [hour, setHour] = useState(dayjs().format("hh:mm a"));
    const [turns, setTurns] = useState([]);
    const [ urlVideo, setUrlVideo] = useState('');
    const [message, setMessage] = useState('');
    //*Contexts
    const { socket } = useContext(SocketContext);
    const { alertRef } = useContext(AlertContext);
    const { setOpenLoader } = useContext(LoaderContext);
    //*Hooks
    const { synth, speak } = useTextSpeech();
    const { id } = useParams();

    useEffect(() => {
        setOpenLoader(true);
        let unsubscribed = true;
        
        if(unsubscribed) {
            onConnectSocket();
            getSede();
        } 

        return () => {
            unsubscribed = false;
            socket.off('backend:conectar-visor');
        }
    }, []);

    useEffect(() => {
        let unsubscribed = true;
        unsubscribed && onCallNewTurn();

        return () => {
            unsubscribed = false;
            socket.off('backend:visualizar-turno');
        }
    }, []);

    useEffect(() => {
        let unsubscribed = true;

        if(unsubscribed) {
            timeId = setInterval(() => {
                setDate(dayjs().format("DD-MM-YYYY"));
                setHour(dayjs().format("hh:mm a"));
            }, 60000);
        } 

        return () => {
            unsubscribed = false;
            clearInterval(timeId);
            timeId = null;
        }
    }, []);

    //*Conecta inicialmente el visor con el socket server
    const onConnectSocket = () => socket.emit('frontend:conectar-visualizador', { id }, response => {
        if(response?.length <= 0) {
            setOpenLoader(false);
            return;
        }

        setTurns(response?.map(e => ({ turn: e.turno.toUpperCase(), module: e.modulo })));
        setOpenLoader(false);
    });

    //*Se ejecuta cada vez que se llame un nuevo turno
    const onCallNewTurn = () => socket.on('backend:visualizar-turno', async (args) => {
        const { sede, ultimos5 } = args;
        
        if(id != sede) return;

        if(ultimos5.length <= 0) {
            setOpenLoader(false);
            return;
        }

        synth ? speak(ultimos5[0]?.modulo_nombre, ultimos5[0]?.turno) : alertRef.current.handleOpen('error', 'El navegador no es compatible con Sintesis de Voz');

        // const wav = await tts.predict({
        //     text: `${ dividirPalabras(ultimos5[0]?.turno) } ${ ultimos5[0]?.modulo_nombre }`,
        //     voiceId: 'es_MX-claude-high',
        // });
          
        // const audio = new Audio();
        // audio.src = URL.createObjectURL(wav);
        // await audio?.play();

        setCalling(true);
        setAnimated('animate__animated animate__bounceIn');
        setTurns(ultimos5.map(e => ({ turn: e.turno.toUpperCase(), module: e.modulo })));
        setOpenLoader(false);
        setTimeout(() => setCalling(false), 4000);
    });

    const getSede = async () => {
        try {
            const response = await fetch(`/api/sedes/${ id }`);

            if(!response.ok) {
                setOpenLoader(false);
                alertRef.current.handleOpen('error', 'Error intentando acceder al recurso.');
                return;
            }

            const { ok, message, data } = await response?.json();

            if(!ok) {
                setOpenLoader(false);
                alertRef.current.handleOpen('error', message);
                return;
            }

            setUrlVideo(data?.url_video);
            setMessage(data?.mensaje);
            setOpenLoader(false);
        } catch (error) {
            console.log(error);
            setOpenLoader(false);
            alertRef.current.handleOpen('error', 'A ocurrido un error interno, intentelo nuevamente.');
            throw new Error(error);
        }
    }

    return (
        <div className={ classes.main }>
            <div className={ classes.containerOne }>
                <img src={ logo } alt="logo" width='80%' />
                <div className={ classes.containerTurns }>
                    <div className={ classes.headerTurns }>
                        <div className={ classes.headerContainerTextTurns }>
                            <span className={ classes.textHeaderTurns }>TURNO</span>
                        </div>
                        <div className={ classes.headerContainerTextTurns }>
                            <span className={ classes.textHeaderTurns }>MÓDULO</span>
                        </div>
                    </div>

                    <div className={ classes.bodyTurns }>
                        {
                            //*PRINCIPAL 
                        }
                        <div className={ classes.containerRows }>
                            <div className={ calling ? [ animated + ' ' + classes.containerFirstRow ] : classes.containerOthersRows }>
                                <div className={ calling ? classes.containerFirstsElements : classes.containerOthersElements }>
                                    <span className={ calling ? classes.firstTextRow : classes.otherTextRow }>{ turns?.length ? turns[0]?.turn : '' }</span>
                                </div>
                                <div className={ calling ? classes.containerFirstsElements : classes.containerOthersElements }>
                                    <span className={ calling ? classes.firstTextRow : classes.otherTextRow }>{ turns?.length ? turns[0]?.module : '' }</span>
                                </div>
                            </div>
                        </div>

                        {
                            //*SECUNDARIOS
                        }
                        <div className={ classes.containerRows }>
                            <div className={ classes.containerOthersRows }>
                                <div className={ classes.containerOthersElements }>
                                    <span className={ classes.otherTextRow }>{ turns?.length ? turns[1]?.turn : '' }</span>
                                </div>
                                <div className={ classes.containerOthersElements }>
                                    <span className={ classes.otherTextRow }>{ turns?.length ? turns[1]?.module : '' }</span>
                                </div>
                            </div>
                        </div>

                        <div className={ classes.containerRows }>
                            <div className={ classes.containerOthersRows }>
                                <div className={ classes.containerOthersElements }>
                                    <span className={ classes.otherTextRow }>{ turns?.length ? turns[2]?.turn : '' }</span>
                                </div>
                                <div className={ classes.containerOthersElements }>
                                    <span className={ classes.otherTextRow }>{ turns?.length ? turns[2]?.module : '' }</span>
                                </div>
                            </div>
                        </div>
                       
                        <div className={ classes.containerRows }>
                            <div className={ classes.containerOthersRows }>
                                <div className={ classes.containerOthersElements }>
                                    <span className={ classes.otherTextRow }>{ turns?.length ? turns[3]?.turn : '' }</span>
                                </div>
                                <div className={ classes.containerOthersElements }>
                                    <span className={ classes.otherTextRow }>{ turns?.length ? turns[3]?.module : '' }</span>
                                </div>
                            </div>
                        </div>

                        <div className={ classes.containerRows }>
                            <div className={ classes.containerOthersRows }>
                                <div className={ classes.containerOthersElements }>
                                    <span className={ classes.otherTextRow }>{ turns?.length ? turns[4]?.turn : '' }</span>
                                </div>
                                <div className={ classes.containerOthersElements }>
                                    <span className={ classes.otherTextRow }>{ turns?.length ? turns[4]?.module : '' }</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={ classes.containerTwo }>
                <div className={ classes.containerVideo }>
                    <video 
                        autoPlay
                        loop
                        style={{ width: '100%', height: '100%' }}
                        src={ urlVideo }
                    ></video>
                </div>
                <div className={ classes.containerFooter }>
                    <div className='marquee'>
                        <span className={ classes.textFooter }>{ message }</span>
                    </div>
                    <div className={ classes.dateFooter }>
                        <span className={ classes.textDate }>{ date }</span>
                        <span className={ classes.textDate }>{ hour }</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

const useStyles = makeStyles({
    main: {
        width: "100%",
        height: '100%',
        background: "#fff",
        display: "flex",
        padding: 40,
        gap: 5,
    },
    containerOne: {
        width: "35vw",
        display: "flex",
        flexFlow: "column noWrap",
        justifyContent: "center",
        alignItems: "center",
        paddingRight: 15
    },
    containerTurns: {
        width: "100%",
        height: "100%",
        paddingTop: 20,
        display: "flex",
        flexFlow: "column noWrap",
        gap: 5,
    },
    headerTurns: {
        width: "100%",
        height: 90,
        display: "flex",
        gap: 5,
    },
    headerContainerTextTurns: {
        width: "50%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#127296",
        borderRadius: 5,
    },
    textHeaderTurns: {
        color: "#fff",
        fontWeight: 600,
        fontSize: 40,
        letterSpacing: 0.5,
    },
    bodyTurns: {
        height: "100%",
        display: 'flex',
        flexFlow: 'column noWrap',
        gap: 5
    },
    containerRows: {
        height: '20%'
    },
    containerFirstRow: {
        display: "flex",
        width: "100%",
        height: "100%",
        gap: 5,
        background: "#D76F21",
        borderRadius: 5,
    },
    containerFirstsElements: {
        width: "50%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    firstTextRow: {
        color: "#fff",
        fontSize: 55,
        fontWeight: 600,
        letterSpacing: 0.5,
    },
    containerOthersRows: {
        display: "flex",
        width: "100%",
        height: "100%",
        background: '#fff',
        gap: 5,
    },
    containerOthersElements: {
        width: "50%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#fff",
        border: "2px solid #127296",
        borderRadius: 5,
    },
    otherTextRow: {
        color: "#127296",
        fontSize: 55,
        fontWeight: 600,
        letterSpacing: 0.5,
    },
    containerTwo: {
        width: "65vw",
        display: "flex",
        flexFlow: "column noWrap",
        gap: 15,
    },
    containerVideo: {
        width: "100%",
        height: "90%",
        border: "2px solid #127296",
        borderRadius: 5,
        background: "#000",
    },
    containerFooter: {
        width: "100%",
        height: "10%",
        border: "2px solid #127296",
        borderRadius: 5,
        display: "flex",
        background: "#127296",
        overflow: "hidden",
        //position: "relative",
    },
    textFooter: {
        color: "#fff",
        fontWeight: 600,
        fontSize: 27,
        width: '100vw',
        letterSpacing: 0.5,
        alignSelf: "center",
        position: 'absolute'
    },
    dateFooter: {
        //position: "absolute",
        //right: 0,
        zIndex: 1,
        width: "25%",
        height: "100%",
        background: "#fff",
        display: "flex",
        flexFlow: "column noWrap",
        justifyContent: "center",
        alignItems: "center",
    },
    textDate: {
        color: "#127296",
        fontWeight: 600,
        fontSize: 23,
        letterSpacing: 0.5,
    },
});